// @flow

import React, {useContext} from 'react';

import {Alert, Experiment} from '../../molecules/baseline/baseline';
import {LOCK__24} from '../../atoms/baseline/baseline';

import SystemContext from '../../context/SystemContext';

import translate from '../../../utils/translations';

import './ProtectPaymentAlert.less';

type Props = {
    translations: Object,
};

export const ProtectPaymentAlert = ({translations}: Props) => {
    const {
        system: {humanReadableBrandName},
    } = useContext(SystemContext);

    return (
        <Experiment name={'vrbo_stx_inbox_payment_banners'} variant={'on'}>
            <Alert
                className="alert-wrapper"
                subtle
                svgClassName="text-info"
                svgMarkup={LOCK__24}
            >
                <p>
                    <strong>
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.conversation.protect.payment.message.title'
                        )}
                    </strong>
                </p>
                <p className="small">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.inbox.conversation.protect.payment.message.content',
                        {
                            brandName: humanReadableBrandName,
                        }
                    )}
                </p>
            </Alert>
        </Experiment>
    );
};
